import React, { Fragment } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Home } from 'react-feather'
import { useIntl } from 'react-intl'

import NextBreadcrumb from '../assets/img/icons/next-breadcrumb.svg'

function BreadcrumbHeader({ path, styles, children }) {
  const intl = useIntl()

  return (
    <Header style={styles}>
      <Breadcrumb>
        <Link to="/">
          <Home color="#6236FF" size={20} />
        </Link>
        {(path || []).map(({ name, icon, path }, index, arr) => {
          return (
            <Fragment key={index + path}>
              <img src={NextBreadcrumb} width="8px" height="8px" alt="" />
              {index === arr.length - 1 ? (
                <span>{intl.formatMessage({ id: name })}</span>
              ) : (
                <Link to={path}>
                  {icon}
                  {intl.formatMessage({ id: name })}
                </Link>
              )}
            </Fragment>
          )
        })}
      </Breadcrumb>
      {children}
    </Header>
  )
}

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`

const Breadcrumb = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 0.8rem;
  font-size: 1.25rem;
  line-height: normal;

  img {
    margin-top: 4px;
  }
`

export default BreadcrumbHeader
